<!--
 * @Author: yuanjianlong
 * @Description: 公共头部
 * @Date: 2021-11-29 16:44:45
 * @LastEditTime: 2022-03-23 15:54:52
 * @FilePath: /teacher-h5/src/components/ComHeader.vue
-->
<template>
  <div :class="[$route.path !== '/supervisionCourse/list' ? 'com-header' : 'com-header-black']">
    <div class="logo" />
    <div v-if="showChromeTip === 1" :class="[$route.path === '/supervisionCourse/list' ? 'chrome-browser-banner-black' : 'chrome-browser-banner']">
      <div class="chrome-tip-wrap">
        <SvgIcon icon="exclamation-mark" class="exclamation-mark" />
        <span class="txt">检测到您当前使用的浏览器不是Chrome浏览器（谷歌浏览器），为保证您的使用体验，请使用Chrome浏览器打开网页。</span>
        <div @click="closeChromeTip" style="height: 16px;line-height: 16px;">
          <SvgIcon icon="close" class="close-icon" />
        </div>
      </div>
    </div>
    <div>
      <slot />
    </div>
    <!-- 空元素占位解决login页面header中浏览器提示布局问题 -->
    <div v-if="$route.path === '/login'" style="width: 173px" />
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    SvgIcon
  },

  computed: {
    ...mapGetters({
      showChromeTip: 'common/showChromeTip'
    })
  },

  methods: {
    isChrome() {
      const ua = navigator.userAgent.toLocaleLowerCase()
      if (ua.match(/edg/) != null) { // edg
        return false
      }
      if (ua.indexOf('qqbrowser') > -1) { // QQBrowser
        return false
      }
      if (ua.indexOf('qq/') > -1) { // QQ
        return false
      }
      if (ua.match(/chrome/) != null) {
        const _mime = function (option, value) {
          var mimeTypes = navigator.mimeTypes
          for (var mt in mimeTypes) {
            if (mimeTypes[mt][option] == value) {
              return true
            }
          }
          return false
        }
        // 参考 https://github.com/mumuy/browser/blob/master/Browser.js
        var is360 = false
        if (window.chrome) {
          var chrome_version = navigator.userAgent.replace(/^.*Chrome\/([\d]+).*$/, '$1')
          if (_mime('type', 'application/360softmgrplugin') || _mime('type', 'application/mozilla-npqihooquicklogin')) {
            is360 = true
          } else if (chrome_version > 36 && window.showModalDialog) {
            is360 = true
          } else if (chrome_version > 45) {
            is360 = _mime('type', 'application/vnd.chromium.remoting-viewer')
            if (!is360 && chrome_version >= 69) {
              is360 = _mime('type', 'application/hwepass2001.installepass2001') || _mime('type', 'application/asx')
            }
          }
        }
        // mac的360极速版本无法区分原声Chrome还是套壳，所以只区分windows的360即可
        return !is360
      }
      // 非chrome内核都提示
      return false
    },
    ...mapMutations({
      setShowChromeTip: 'common/setShowChromeTip'
    }),
    closeChromeTip() {
      this.setShowChromeTip(0)
    }
  },

  mounted() {
    if (this.showChromeTip === 0) {
      this.setShowChromeTip(0)
    } else {
      const isChrome = this.isChrome()
      if (!isChrome) {
        this.setShowChromeTip(1)
      } else {
        this.setShowChromeTip(0)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/static/css/base.less';

.com-header {
  height: 52px;
  background: #FFFFFF;
  /* Shadow01 */
  box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.04), 0px 2px 4px rgba(96, 97, 112, 0.16);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 16px;
  .exclamation-mark {
    font-size: 16px;
    margin-right: 5px;
    fill:#FF8800;
  }
  .close-icon {
    font-size: 16px;
    cursor: pointer;
    fill:#98A2B2;
  }
  .logo {
    width: 126px;
    height: 26px;
    background: center url('../static/images/logo/header-logo.png') no-repeat;
    background-size: 126px auto;
  }
  .chrome-browser-banner {
    margin: 0 20px;
    width: calc(100% - 126px - 193px - 80px);
    .chrome-tip-wrap {
      display: flex;
      align-items: center;
      background: #FFF8E5;
      border-radius: 6px;
      padding: 12px 16px;
      max-width: 749px;
      .txt {
        display: inline-block;
        width: calc(100% - 40px);
        white-space: nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
        font-family: 'Microsoft YaHei UI';
        font-size: 12px;
        letter-spacing: 0.04em;
        color: #505873;
      }
    }
  }
}
.com-header-black {
  height: 52px;
  background: #191B22;
  /* Shadow01 */
  box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.04), 0px 2px 4px rgba(96, 97, 112, 0.16);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 16px;
  .logo {
    width: 126px;
    height: 26px;
    background: center url('../static/images/logo/header-logo-black.png') no-repeat;
    background-size: 126px auto;
  }
  .chrome-browser-banner-black {
    margin: 0 20px;
    width: calc(100% - 126px - 402px - 40px - 140px);
    .chrome-tip-wrap {
      display: flex;
      align-items: center;
      background: #FFF8E5;
      border-radius: 6px;
      padding: 12px 16px;
      max-width: 749px;
      .txt {
        display: inline-block;
        width: calc(100% - 40px);
        white-space: nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
        font-family: 'Microsoft YaHei UI';
        font-size: 12px;
        letter-spacing: 0.04em;
        color: #505873;
      }
    }
  }
}
</style>